import { Layout } from '@/components/Layout';
import { LookupTable } from '../components/LookupTable';
import { lookupsApi } from '../api';

export default function SexPage() {
  return (
    <Layout>
      <div className="container mx-auto px-4 py-8">
        <LookupTable
          title="Sexos"
          description="Gestiona los sexos de animales"
          queryKey="sex"
          listFn={lookupsApi.listSex}
          createFn={lookupsApi.createSex}
          updateFn={lookupsApi.updateSex}
          deleteFn={lookupsApi.deleteSex}
        />
      </div>
    </Layout>
  );
}
